import React, { useState, useEffect } from 'react';
import { NavLink, useLocation, Link } from 'react-router-dom';
import classnames from 'classnames';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Paper from '@mui/material/Paper';

import img_home from '../../../src/images/common/i_bot_nav_01.svg';
import img_home_on from '../../../src/images/common/i_bot_nav_01_on.svg';
import img_hospitalCare from '../../../src/images/common/i_bot_nav_02.svg';
import img_hospitalCare_on from '../../../src/images/common/i_bot_nav_02_on.svg';
import img_alarm from '../../../src/images/common/i_bot_nav_03.svg';
import img_alarm_on from '../../../src/images/common/i_bot_nav_03_on.svg';
import img_mypage from '../../../src/images/common/i_bot_nav_04.svg';
import img_mypage_on from '../../../src/images/common/i_bot_nav_04_on.svg';
import img_fullmenu from '../../../src/images/common/i_bot_nav_05.svg';
import img_fullmenu_on from '../../../src/images/common/i_bot_nav_05_on.svg';

const Navbar = () => {
    const location = useLocation();
    const currentPath = location.pathname;

    const [value, setValue] = React.useState(1);

    //새로운 알림 여부 
    const [newAlarm, setNewAlarm] = useState(true);

    useEffect(() => {
        switch (currentPath) {
            case '/HomeCareMain':
                setValue(1);
                break;
            case '/hospitalCare':
                setValue(2);
                break;
            case '/Alarm':
                setValue(3);
                break;
            case '/MyPageMain':
            case '/MyPageMain/summary':
            case '/MyPageMain/detail':
                setValue(4);
                break;
            case '/TotalMenu':
                setValue(5);
                break;
            default:
                setValue(0);
        }
    }, [currentPath]);

    


    return (
        <>
            <Paper
                sx={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    zIndex: 10,
                    height: 'var(--sp-56)',
                }}
                elevation={5}
            >
                <BottomNavigation
                    showLabels
                    value={value}
                    onChange={(event, newValue) => {
                        setValue(newValue);
                    }}
                    sx={{
                        '& .MuiBottomNavigationAction-root': {
                            userSelect: 'none !important',
                            WebkitUserSelect: 'none !important',
                            WebkitTouchCallout: 'none !important',
                            WebkitUserDrag: 'none !important',
                        },
                        '& a': {
                            userSelect: 'none !important',
                            WebkitUserSelect: 'none !important',
                            WebkitTouchCallout: 'none !important',
                            WebkitUserDrag: 'none !important',
                        },
                        '& img': {
                            pointerEvents: 'none !important',
                            userSelect: 'none !important',
                            WebkitUserDrag: 'none !important',
                        }
                    }}
                >
                    <BottomNavigationAction
                    
                        label="홈케어"
                        icon={
                            currentPath === '/HomeCareMain' ? (
                                <img 
                                    src={img_home_on} 
                                    className='animation-4'
                                    draggable={false} 
                                    alt=""
                                />
                            ) : (
                                <img 
                                    src={img_home} 
                                    draggable={false} 
                                    alt=""
                                />
                            )
                        }
                        component={Link}
                        to="/HomeCareMain"
                        value={1}
                        className={value === 1 ? 'on' : ''}
                        aria-label={value === 1 ? "홈케어 메뉴 활성화됨" : "홈케어 메뉴 비활성화"}
                        
                    />

                    <BottomNavigationAction
                        label="병원케어"
                        icon={
                            currentPath === '/hospitalCare' ? (
                                <img 
                                    src={img_hospitalCare_on} 
                                    className='animation-4'
                                    draggable={false} 
                                    alt=""
                                />
                            ) : (
                                <img 
                                    src={img_hospitalCare} 
                                    draggable={false} 
                                    alt=""
                                />
                            )
                        }
                        component={Link}
                        to="/hospitalCare"
                        value={2}
                        className={value === 2 ? 'on' : ''}
                        aria-label={value === 2 ? "병원케어 메뉴 활성화됨" : "병원케어 메뉴 비활성화"}
                    />
                    
                    <BottomNavigationAction
                        label="알림"
                        icon={
                            currentPath === '/Alarm' ? (
                                <img 
                                    src={img_alarm_on} 
                                    className='animation-4'
                                    draggable={false} 
                                    alt=""
                                />
                            ) : (
                                <img 
                                    src={img_alarm} 
                                    draggable={false} 
                                    alt=""
                                />
                            )
                        }
                        component={Link}
                        to="/Alarm"
                        value={3}
                        className={classnames({ on: value === 3, /*new: newAlarm*/ })}
                        aria-label={value === 3 ? "알림 메뉴 활성화됨" : "알림 메뉴 비활성화"}

                    >
                    </BottomNavigationAction>
                    
                    <BottomNavigationAction
                        label="내정보"
                        icon={
                            currentPath === '/MyPageMain' || currentPath === '/MyPageMain/summary' || currentPath === '/MyPageMain/detail'? (
                                <img 
                                    src={img_mypage_on} 
                                    className='animation-4' 
                                    draggable={false} 
                                    alt=""
                                />
                            ) : (
                                <img 
                                    src={img_mypage} 
                                    draggable={false} 
                                    alt=""
                                />
                            )

                        }
                        component={Link}
                        to="/MyPageMain"
                        value={4}
                        className={value === 4 ? 'on' : ''}
                        aria-label={value === 4 ? "내정보 메뉴 활성화됨" : "내정보 메뉴 비활성화"}
                    />

                    <BottomNavigationAction
                        label="전체메뉴"
                        icon={
                            currentPath === '/TotalMenu' ? (
                                <img 
                                    src={img_fullmenu_on} 
                                    className='animation-4'
                                    draggable={false} 
                                    alt=""
                                />
                            ) : (
                                <img 
                                    src={img_fullmenu} 
                                    draggable={false} 
                                    alt=""
                                />
                            )
                        }
                        component={Link}
                        to="/TotalMenu"
                        value={5}
                        className={value === 5 ? 'on' : ''}
                        aria-label={value === 5 ? "전체메뉴 활성화됨" : "전체메뉴 비활성화"}
                    />
                </BottomNavigation>
            </Paper>
        </>
    );
};

export default Navbar;
